<template>

  <v-tour v-if="showVueTour" name="myTour" id="vtour-custom" :steps="steps" :options="vueTourOptions" :callbacks="myCallbacks">
    <template slot-scope="tour">
      <transition name="fade">
        <v-step
            v-if="tour.currentStep===index && (index === currentStep + 1 || index === 0)"
            v-for="(step, index) of tour.steps"
            :key="tour.currentStep"
            :step="step"
            :previous-step="tour.previousStep"
            :next-step="tour.nextStep"
            :stop="tour.stop"
            :skip="tour.skip"
            :is-first="tour.isFirst"
            :is-last="tour.isLast"
            :labels="tour.labels"
            :highlight="!tour.isLast? tour.highlight : !tour.highlight"
        >
          <template>
<!--            <div slot="header">-->
<!--              <div class="v-step__header">-->
<!--                <div>{{ step.header.title }}</div>-->
<!--              </div>-->
<!--            </div>-->
            <div slot="content" class="slot-content">
              <div class="v-step__content">
                <h3>{{ step.content.title }}</h3>
                <p>{{ step.content.description }}</p>
              </div>
            </div>
            <div slot="actions" class="slot-actions">
              <b-button v-if="!tour.isLast" rounded class="red-button" @click="tour.stop">
                {{ $t("skip")}}
              </b-button>
              <b-button v-if="!tour.isLast" rounded class="white-button" @click="nextStep(tour)">
                {{ $t("continue_the_visit")}}
              </b-button>
              <b-button v-if="tour.isLast" rounded class="red-button" @click="tour.stop">
                {{ $t("finish")}}
              </b-button>
              <div class="vue-control" v-if="steps.length>1">
                <span v-for="(step, index) in steps" :key="index"
                   class="vue-slide-track" @click="jumpToStep(tour, index)">
                  <div v-if="tour.currentStep === index"></div>
                </span>
              </div>
            </div>
          </template>
        </v-step>
      </transition>
    </template>
  </v-tour>


</template>

<script>
import {mapState} from "vuex";

export default {
  name: "VueTour",
  data() {
    return {
      showVueTour:true,
      vueTourOptions: {
        highlight: true,
        startTimeout: 1000
      },
      myCallbacks: {
        onNextStep: this.changePageTourCallback,
        onStop: this.stopTourCallback,
      },
    }
  },
  computed: {
    ...mapState({
      steps: state => state.vuetour.steps,
      currentStep: state => state.vuetour.currentStep,
      vueTourOn: state => state.vuetour.vueTourOn,
      locale: state => state.settings.locale,
    })
  },
  created() {
    this.$root.$on('start-tour', (script_id) => {
      this.showVueTour=true;
      this.startTour(script_id);
    })
  },
  mounted() {
    if(this.vueTourOn) {
      this.$tours["myTour"].start(this.currentStep+1);
    }
  },
  beforeDestroy() {
    this.$root.$off("start-tour");
  },
  watch: {
    currentStep(value) {
      setTimeout(() => {
        window.scroll({
          top: 0,
          left: 0,
          behavior: 'smooth'
        });
      }, 150);
    }
  },

  methods: {
    jumpToStep(tour, index) {
      // @todo fix go to previous (only go to first step)
      if (index === tour.currentStep - 1) tour.previousStep()
      else if (tour.currentStep > index - 1) {
        for (let i = 0; i < tour.currentStep - index; i++) {
          tour.previousStep()
        }
      } else {
        for (let i = 0; i < index - tour.currentStep; i++) {
          tour.nextStep()
        }
      }

    },
    nextStep(tour) {
      if (tour.steps[tour.currentStep + 1].target === "[data-v-step='capacity-gravity']") {
        this.$root.$emit('switch-calculator-tab', 'results')
        setTimeout(() => {
          tour.nextStep()
        }, 500)
      } else tour.nextStep()
    },
    changePageTourCallback (currentStep) {
      console.log(currentStep)
      // this.$store.commit('vuetour/setCurrentStep', currentStep);
      if (!this.steps[currentStep + 1].route || (this.steps[currentStep + 1].route && !this.steps[currentStep + 1].route.delay)) this.$store.commit('vuetour/setCurrentStep', currentStep);
      if (this.steps[currentStep + 1].route) {
        this.$router.replace({path: this.steps[currentStep + 1].route.name, query: this.steps[currentStep + 1].route.query}).then(() => {
          console.log('route replace')
          this.$store.commit('vuetour/setVueTourOn', true);

          setTimeout(() => {
            this.$store.commit('vuetour/setCurrentStep', currentStep);
          }, 2000)
        })

        // this.$router.push({path: this.steps[currentStep + 1].route.name, query:this.steps[currentStep + 1].route.query})
        // this.$router.push({ name: this.steps[currentStep + 1].route.name, params: {name: this.steps[currentStep + 1].route.params.name, id: this.steps[currentStep + 1].route.params.id }});
      }
    },
    async stopTourCallback () {
      this.showVueTour=false;
      this.$store.commit('vuetour/setVueTourOn', false);
      await this.$router.replace({path: '/search'}).catch(()=>{});
      await this.$root.$emit('end-tour');
    },
    async startTour(script_id) {
      await this.$store.commit('vuetour/setSteps', []);
      await this.$store.dispatch('vuetour/fetchScript', {id: script_id, locale:this.locale})
          .finally(() =>
          {
            // this.$store.commit('vuetour/setVueTourOn', false);

            if (this.steps[0] && this.steps[0].route) {
              this.$store.commit('vuetour/setCurrentStep', -1);
              this.$store.commit('vuetour/setVueTourOn', true);
              this.$router.replace({path: this.steps[0].route.name, query:this.steps[0].route.query})
             } else this.$tours["myTour"].start();
          }
      );
    }
  }
}
</script>

<style lang="scss">
.v-tour__target--highlighted {
  box-shadow: 0 0 0 99999px rgba(0, 0, 0, .4) !important;
  border-radius: 20px;
  border: $brand-red 4px solid;
}

#vtour-custom {

  .v-step {
    background-color: $brand-red ;
    border-radius: 20px;
    min-width: 450px;
    min-height: 300px;
    text-align: left;

    @media #{$mq_phone} {
      min-width: 260px;
    }
  }

  .vue-control {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 15px;
    @media #{$mq_phone} {
      margin-top: 8px;
    }

    .vue-slide-track {
      margin: 0 5px;
      border-radius: 50%;
      height: 20px;
      width: 20px;
      border: 2px solid $white;
      padding: 3px;

      div {
        height: 10px;
        width: 10px;
        background-color: $white;
        border-radius: 50%;
      }
    }
  }

  #v-step-39b1cc7c, #v-step-39b1c4fa, #v-step-39b1bd78, #v-step-39b1b5f6 {
    width: 270px;
    @media #{$mq_phone} {
    min-height: 200px;
  }
  }

  .slot-content {
    @media #{$mq_phone} {
    line-height: 0.9;
  }
  }
  #v-step-39b1ae74 {
    top: 40% !important;
    left: 50% !important;
    transform: translate(-50%, -50%) !important;
    box-shadow: 0 0 0 99999px rgba(0, 0, 0, .4) !important;

    @media #{$mq_phone} {
      top: 30% !important;
    }

    .v-step__arrow {
      display: none;
    }
  }

  .v-step__arrow:before {
    background-color: $brand-red;
    border-radius: 10%;
  }

  .v-step__header {
    background-color: $brand-red;
    border-radius: 20px;
    font-weight: bolder;
    font-size: 30px;
    margin: 5px 0px 20px 5px;
  }

  .slot-actions{
    margin-top: 40px;
    text-align: center;

    @media #{$mq_phone} {
      margin-top: 0;
    }
  }

  h3 {
    font-size: 25px;
    font-weight: bolder;
    margin: 40px 0px 25px 5px;
    text-align: center;
    @media #{$mq_phone} {
      font-size: 22px;
      margin: 20px 0px 20px 5px;
    }
  }

  p{
    margin: 15px 0px 30px 5px;
    line-height: 18px;
    font-size: 17px;
    text-align: center;
    @media #{$mq_phone} {
      font-size: 16px;
      margin-bottom: 10px;
    }
  }

  .white-button {
    text-transform: uppercase;
    color: $brand-red;
    font-weight: 500;
    margin: 10px;
    @media #{$mq_phone} {
      margin: 0;
      font-size: 16px;
    }
  }

  .red-button {
    text-transform: uppercase;
    background-color: $brand-red;
    color: $white;
    font-weight: 500;
    margin: 10px;
    @media #{$mq_phone} {
     font-size: 16px;
    }
  }


}
</style>
